<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-configurations-system" v-loading="isLoading" element-loading-text="This process may take several minutes, please be patient.">
    <div class="action-button" v-if="authUser.isDevelopment">
      <el-button type="danger" @click="handleResetAlerts">Reset Alerts Data</el-button>
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';
import AuthService from '../../service/auth';

export default {
  name: 'wy-settings-system',

  data() {
    return {
      isLoading: false,
      isUpdated: false
    }
  },

  computed: {
    ...mapGetters(['authUser']),
  },

  methods: {
    async handleResetAlerts() {
      this.isLoading = true;
      let res = await AuthService.resetAlert(this.authUser);
      this.isLoading = false;
      if(!res) {
        this.$root.showNotificationLocale("error", "error.serverErrorTitle", "error.serverErrorMsg");
      }
      else if(res.status == 200) {
        this.$root.showNotificationLocale("success", "configurations.resetAlertsTitle", "configurations.resetAlertsMessage", {callback: () => {
          this.$root.showProcessListDrawer({visible: true, refreshList: true, duration: 5000, tab: "alerts"});
        }});
      }
    }
  },

  beforeDestroy() {
    if(this.isUpdated) {
      location.reload()
    }
  }
};
</script>

<style lang="scss">
.wy-configurations-system {
  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .action-button {
    margin-bottom: 20px;
  }
}
</style>